// Expandable photo caption: clamps long captions and shows a "Lees verder"
// button only when the text is actually cut off. Registered as
// Alpine.data('expandableCaption').
//
// Whether a caption overflows depends on the viewport, so it is measured rather
// than guessed from character count. The measurement is repeated on resize,
// because a caption that fits on desktop may well wrap on mobile.
export default function registerExpandableCaption(Alpine) {
    Alpine.data('expandableCaption', (startOpen = false) => ({
        open: startOpen,
        clamped: false,

        init() {
            // An open caption is never clamped, so there is nothing to measure.
            if (this.open) {
                return;
            }

            this.$nextTick(() => this.measure());

            this.onResize = () => this.measure();
            window.addEventListener('resize', this.onResize);
        },

        destroy() {
            if (this.onResize) {
                window.removeEventListener('resize', this.onResize);
            }
        },

        measure() {
            const text = this.$refs.text;

            if (! text || this.open) {
                return;
            }

            // A single pixel of slack: sub-pixel line heights otherwise report
            // an overflow on captions that fit exactly.
            this.clamped = text.scrollHeight > text.clientHeight + 1;
        },
    }));
}
